<template>
  <div id="login-form">
    <div class="field">
      <label class="label">User Name</label>
      <div class="control">
        <input class="js-username input" type="email" v-model="username" placeholder="User Name">
      </div>
    </div>

    <div class="field">
      <label class="label">Password</label>
      <div class="control">
        <input class="js-password input" type="password" v-model="password" placeholder="Password">
      </div>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link"
          v-on:click="handleLogin"
          :disabled="isDisabled">Log In</button>
      </div>
    </div>
    <Modal
      v-bind:modal-title="modalTitle"
      v-bind:modal-body="modalBody"
      v-bind:is-active="modalIsActive"
      v-on:close-modal="closeModal" />
  </div>
</template>

<script>
import Modal from '../components/Modal.vue';
import API from '../services/clubhouse';

export default {
  name: 'LoginForm',
  components: {
    Modal,
  },
  data() {
    return {
      sharedStore: this.$root.store,
      username: '',
      password: '',
      modalTitle: '',
      modalBody: '',
      modalIsActive: false,
    };
  },
  computed: {
    isDisabled() {
      let isDisabled = false;
      if (!this.formIsValid()) {
        isDisabled = true;
      }
      return isDisabled;
    },
  },
  methods: {
    formIsValid() {
      let isValid = true;
      if (this.username === '' || this.password === '') {
        isValid = false;
      }
      if (!this.validateEmail(this.username)) {
        isValid = false;
      }
      return isValid;
    },
    handleLogin() {
      const isValid = this.formIsValid();
      if (isValid) {
        this.submitLogin(this.username, this.password);
      } else {
        this.modalTitle = 'Invalid Input';
        this.modalBody = 'The email or password you entered is invalid. Please check the form and try again.';
        this.modalIsActive = true;
      }
    },
    validateEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    closeModal() {
      this.modalIsActive = false;
    },
    submitLogin(username, password) {
      API.postLogin(username, password)
        .then((data) => {
          if (data.error) {
            this.modalTitle = 'Server Error';
            this.modalBody = 'There was a problem authenticating your account. Please check your credentials and try agian.';
            this.modalIsActive = true;
            this.isDisabled = false;
          } else {
            this.sharedStore.setToken(data.token);

            // Wait 1 second, because...Safari.
            setTimeout(() => {
              this.isDisabled = false;
              window.location.href = '/dashboard';
            }, 1000);
          }
        })
        .catch((error) => {
          console.error(`error: ${error}`);
          this.isDisabled = false;
        })
        .finally(() => {
          // Done
        });
    },
  },
};
</script>

<style scoped lang="scss">
  #login-form {
    margin-top: 30px;
    margin-bottom: 60px;
    max-width: 768px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
